import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreValueItems } from "../../api/apiValueItems";
import parseError from "../../utils/parseError";

export function useRestoreAllValueItems() {
    const queryClient = useQueryClient();

    const { mutate: restoreAllItemsMutate, isPending } = useMutation({
        mutationFn: massRestoreValueItems,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["value-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore value items");
        },
    });

    return { restoreAllItemsMutate, isPending };
}
